import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Main from '@/components/Main'
import User from '@/components/user/User'

import indx from '@/components/index/router'
import entr from '@/components/entries/router'

import syst from '@/components/syst/router'
import papr from '@/components/papr/router'
import awar from '@/components/awar/router'
import book from '@/components/book/router'
import ctra from '@/components/ctra/router'
import perf from '@/components/perf/router'
import web from '@/components/web/router'
import proj from '@/components/proj/router'
import inte from '@/components/inte/router'
import staff from '@/components/staff/router'
import integrity from '@/components/integrity/router'
import achi from '@/components/hss_achi/router'
import agmt from '@/components/agmt/router'
import coop from '@/components/ol_ctra/router'
import olCtra from '@/components/coop/router'
import batchCreate from '@/components/proj/batch_create/router'
import seal from '@/components/seal/router'

import deptFund from "@/components/datamining/deptfund/router.js";


Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  scrollBehavior(to, from, savedPosition) {
    // { x: number, y: number }
    // { selector: string, offset? : { x: number, y: number }} (offset 只在 2.6.0+ 支持)
    if (savedPosition) {
      return savedPosition
    } else {
      return {selector: '.main-content-card', offset: {x: 0, y: 48}}
    }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {public: true}
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {
          path: '/user',
          name: 'user',
          component: User
        },
        ...indx.routes,
        ...entr.routes,
        ...syst.routes,
        ...papr.routes,
        ...proj.routes,
        ...awar.routes,
        ...book.routes,
        ...ctra.routes,
        ...perf.routes,
        ...web.routes,
        ...inte.routes,
        ...staff.routes,
        ...integrity.routes,
        ...achi.routes,
        ...batchCreate.routes,
        ...agmt.routes,
        ...coop.routes,
        ...deptFund.routes,
        ...olCtra.routes,
        ...seal.routes
      ]
    }
  ]
})
